import React from "react"

const SvgClose = (props) => (
  <svg viewBox="0 0 18 18" {...props}>
    <path
      d="M16.5.086L17.914 1.5l-7.5 7.5 7.5 7.5-1.414 1.414-7.5-7.5-7.5 7.5L.086 16.5l7.5-7.5-7.5-7.5L1.5.086l7.5 7.5 7.5-7.5z"
      fillRule="evenodd"
    />
  </svg>
)

export default SvgClose
